import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {
    CDataTable, CButton, CModal, CModalHeader, CModalBody, CModalFooter,
} from '@coreui/react'

import {Link} from 'react-router-dom';
import {getEntities, deleteEntity} from '../../reducers/apiKeyReducer';
import {contextAwareUrl} from "../../helpers";

const ApiKeys = () => {
    const dispatch = useDispatch();
    const currentEnvironment = useSelector(state => state.context.currentEnvironment);
    const keys = useSelector(state => state.apikey.entities);
    const loading = useSelector(state => state.apikey.loading);
    const updateSuccess = useSelector(state => state.apikey.updateSuccess);
    const errorMessage = useSelector(state => state.apikey.errorMessage);
    const [deleteModal, setDeleteModal] = useState(false);
    const [keyToDelete, setKeyToDelete] = useState(null);

    const toggleDeleteModal = (key)=> {
        setKeyToDelete(key);
        setDeleteModal(!deleteModal);
    };

    const confirmDelete = () => {
        dispatch(deleteEntity(keyToDelete.id));
    };

    useEffect(() => {
        if (updateSuccess) {
            dispatch(getEntities(currentEnvironment.id));
            setKeyToDelete(null);
            setDeleteModal(false);
        }
    }, [updateSuccess]);

    // initial load request events
    useEffect(() => {
        dispatch(getEntities(currentEnvironment.id));
    }, [currentEnvironment]); // reload if environment changes

    const fields = [
        {key: 'name', _style: {width: '30%'}},
        {key: 'key', _style: {width: '30%'}},
        {
            key: 'edit_link',
            label: '',
            _style: {width: '1%'},
            sorter: false,
            filter: false
        },
        {
            key: 'delete_link',
            label: '',
            _style: {width: '1%'},
            sorter: false,
            filter: false
        }
    ];

    return (
        <>
            <CModal show={deleteModal} onClose={toggleDeleteModal}>
                <CModalHeader closeButton>Delete</CModalHeader>

                <CModalBody>
                    Are you sure?
                </CModalBody>

                <CModalFooter>
                    <CButton color="danger" onClick={confirmDelete}>Confirm</CButton>{' '}
                    <CButton color="secondary" onClick={toggleDeleteModal}>Cancel</CButton>
                </CModalFooter>
            </CModal>

            <Link to={contextAwareUrl("/apikeys/new")} className="btn btn-primary w-fit ml-auto mb-3 d-flex align-items-center">
                <span className="cil-plus btn-icon mr-2"></span> Create new api key
            </Link>

            {keys && keys.length > 0 ? (
                <div className={'card shadow-none'}>
                    <div className={'card-body table-responsive'}>
                        <h5 className={'card-title'}>Api Keys</h5>

                        <CDataTable
                            items={keys}
                            fields={fields}
                            columnFilter
                            tableFilter
                            itemsPerPageSelect
                            itemsPerPage={50}
                            hover
                            sorter
                            pagination
                            striped
                            scopedSlots={{
                                'edit_link':
                                    (item) => {
                                        return (
                                            <td className="py-2">
                                                <CButton
                                                    color="primary"
                                                    shape="rounded"
                                                    size="sm"
                                                    className="d-flex align-items-center"
                                                    to={contextAwareUrl('/apikeys/' + item.id + '/edit')}>
                                                    <span className={'cil-cog cil-button mr-2'}></span> Edit
                                                </CButton>
                                            </td>
                                        )
                                    },
                                'delete_link':
                                    (item) => {
                                        return (
                                            <td className="py-2">
                                                <CButton
                                                    color="danger"
                                                    shape="rounded"
                                                    size="sm"
                                                    className="d-flex align-items-center"
                                                    onClick={() => {toggleDeleteModal(item)}}>
                                                    <span className={'cil-cog cil-button mr-2'}></span> Delete
                                                </CButton>
                                            </td>
                                        )
                                    },
                            }}
                        />
                    </div>
                </div>
            ) : (
                <>
                    {loading ? (
                        <div>Loading...</div>
                    ) : (
                        <>
                            {errorMessage ? (
                                <div className="alert alert-danger">{errorMessage.message}</div>
                            ) : (
                                <div className="alert alert-warning">No api keys found</div>
                            )}
                        </>
                    )}
                </>
            )}
        </>
    )
};

export default ApiKeys;
